import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';
import Header from '../common/Header';
import Footer from '../common/Footer';

import { postAe } from '../../redux/action';

import './ae.css'; 
import '../common/common.css'; 

import aeBanner from '../../images/aeBanner.png';
import gearrow1 from '../../images/gearrow_1.png';
import gearrow2 from '../../images/gearrow_2.png';
import gearrow3 from '../../images/gearrow_3.png';
import aePlay from '../../images/aePlay.png';

class AeManagement extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	res: {}
	    };
    }

	componentWillMount() {
		
		let token = window.localStorage.getItem("token");
		if (!token) {
			window.location.href = "/login";
		}

	}


	componentDidMount() {
			// this.props.moduleType
			postAe({ "moduleType": this.props.moduleType }).then(res => {
				this.setState({ res: res.data })
			}, this);

	}

	renderSubBodyItem(idx) {

		const aeitems = [
			{ name: "Interstitial lung disease/pneumonitis", url: "/ae-management/pneumonitis" },
			{ name: "Left ventricular ejection fraction decrease", url: "/ae-management/lvef-decrease" },
			{ name: "Neutropenia", url: "/ae-management/neutropenia" },
			{ name: "Embryo-fetal toxicity", url: "/ae-management/embryo-fetal" },
		];

		switch(idx) {
			case 1:
				return (
					<div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_desc }}></div>
						</div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section2_desc }}></div>
						</div>
						<div className="subBodyItem">
							{
								aeitems.map((aei, idx) => {
									return (
										<div className="aeItem">
											<a href={aei.url}><span>{aei.name}</span><img src={aePlay} /></a>
										</div>	
									);
								})
							}
						</div>
					</div>
				);
			case 2:
				return (
					<div>
						<div className="subBodyItem">
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_title }}></div>
							<div dangerouslySetInnerHTML={{ __html: this.state.res.section1_desc }}></div>
						</div>
						<div className="subBodyItem">
							<div className="roundCornerRemark centerAlign">
								<div dangerouslySetInnerHTML={{ __html: this.state.res.remark }}></div>
							</div>
						</div>
					</div>
				);
			default:
				return ""
		}
		
	}


	render() {


		const aritems = [
			{
				name: "Gastrointestinal ARs",
				items: [
					{ name: "Nausea", url: "/ae-management/nausea" },
					{ name: "Vomiting", url: "/ae-management/vomiting" },
					{ name: "Constipation", url: "/ae-management/constipation" },
					{ name: "Diarrhea", url: "/ae-management/diarrhea" }
				]
			},
			{
				name: "Hematologic ARs",
				items: [
					{ name: "Anemia ", url: "/ae-management/anemia " },
					{ name: "Neutrophil count decreased (neutropenia)", url: "/ae-management/nc-decrease" },
					{ name: "Platelet count decreased", url: "/ae-management/pc-decrease" },
					{ name: "White blood cell count decreased", url: "/ae-management/wbcc-decrease" }
				]
			},
			{
				name: "Other frequently occurring ARs",
				items: [
					{ name: "Decreased appetite (anorexia)", url: "/ae-management/appetite" },
					{ name: "Fatigue", url: "/ae-management/fatigue" },
					{ name: "Alopecia ", url: "/ae-management/alopecia" },
					{ name: "ALT and AST increased", url: "/ae-management/atl" }
				]
			}
			
		];

		return(
			<div className="aeContainer aeParentContainer">
				<Header urlKey={this.props.urlKey} moduleType={this.props.moduleType} />
				<div className="mainContainer">
					<img className="banner" src={aeBanner} />
					{
						(this.props.moduleType == "special-warning") ? (
							<div>
								<div className="sectionContainer">
									<div className="headline containerMaxWidth">
										<h2>Special warnings and precautions for use</h2>
									</div>
									<div className="bodyContent containerMaxWidth">
										{this.renderSubBodyItem(1)}
									</div>
								</div>
								<div className="sectionContainer">
									
									{
										(this.state.res.reference) ? (
											<div className="referenceContainer sectionContainer">
												<div className="headline containerMaxWidth">
													<h2>References</h2>
												</div>
												<div className="bodyContent containerMaxWidth" dangerouslySetInnerHTML={{ __html: this.state.res.reference }} >
												</div>
											</div>
										) : ""
									}
									
								</div>
							</div>
						) : ""
					}
					{
						(this.props.moduleType == "common-ars") ? (
							<div>
								<div className="sectionContainer">
									<div className="headline containerMaxWidth">
										<h2>Common ARs associated with <br/> trastuzumab deruxtecan</h2>
									</div>
									<div className="bodyContent containerMaxWidth">
										{this.renderSubBodyItem(2)}
									</div>
								</div>
								{
									aritems.map(ar => {
										return (
											<div className="sectionContainer">
												<div className="headline containerMaxWidth">
													<h2>{ar.name}</h2>
												</div>
												<div className="bodyContent containerMaxWidth">
													<div className="subBodyItem">
														{
															ar.items.map((aei, idx) => {
																return (
																	<div className="aeItem">
																		<a href={aei.url}><span>{aei.name}</span><img src={aePlay} /></a>
																	</div>	
																);
															})
														}
													</div>
												</div>
											</div>
										);
									})
								}
								{
										(this.state.res.reference) ? (
											<div className="referenceContainer sectionContainer">
												<div className="headline containerMaxWidth">
													<h2>References</h2>
												</div>
												<div className="bodyContent containerMaxWidth" dangerouslySetInnerHTML={{ __html: this.state.res.reference }} >
												</div>
											</div>
										) : ""
									}
							</div>
						) : ""
					}
					
				</div>
				<Footer urlKey={this.props.urlKey} />
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(AeManagement));